import { render, staticRenderFns } from "./RegistryEntries.vue?vue&type=template&id=24d1fab4&scoped=true&"
import script from "./RegistryEntries.vue?vue&type=script&lang=js&"
export * from "./RegistryEntries.vue?vue&type=script&lang=js&"
import style0 from "./RegistryEntries.vue?vue&type=style&index=0&id=24d1fab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1fab4",
  null
  
)

export default component.exports